/**
 * Волна D (docs/MIGRATION_ROUTER.md §5).
 * Было: <PrivateRoute exact path='/invite/:partnerId'>.
 * /invite/courier (одним сегментом) матчится здесь с partnerId='courier' —
 * ровно как в легаси-Switch (exact-роут стоял раньше courier-роута);
 * /invite/courier/<id> уходит в invite/courier/$courierId.tsx
 * (в TanStack статик-сегмент ранжируется выше параметра).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import RegisterPage from '@routes/RegisterPage';

export const Route = createFileRoute('/invite/$partnerId')({
  component: () => (
    <CacheDataRoute component={RegisterPage} path='/invite/:partnerId' />
  )
});
